const SEAT_MAPS = {
    ACTOR_HALL: {
        ROWS_AMOUNT: 14,
        MAX_SEATS_AMOUNT: 15,
        SEATS_LEFT_TO_RIGHT: false,
        INIT_MOBILE_SCALE: 0.55,
        INIT_DESKTOP_SCALE: 0.9,
        CUSTOM_ROW_NAMES: false,
        ROW_NAMES: []
    },
    VOZDVYZHENSKY_BOUTIQUE_HOTEL: {
        ROWS_AMOUNT: 8,
        MAX_SEATS_AMOUNT: 12,
        SEATS_LEFT_TO_RIGHT: true,
        INIT_MOBILE_SCALE: 0.65,
        INIT_DESKTOP_SCALE: 1,
        CUSTOM_ROW_NAMES: false,
        ROW_NAMES: []
    },
    CINEMA: {
        ROWS_AMOUNT: 3,
        MAX_SEATS_AMOUNT: 4,
        SEATS_LEFT_TO_RIGHT: false,
        INIT_MOBILE_SCALE: 1,
        INIT_DESKTOP_SCALE: 1,
        CUSTOM_ROW_NAMES: false,
        ROW_NAMES: []
    },
    CHERVONA_TROIANDA: {
        ROWS_AMOUNT: 11,
        MAX_SEATS_AMOUNT: 12,
        SEATS_LEFT_TO_RIGHT: true,
        INIT_MOBILE_SCALE: 0.6,
        INIT_DESKTOP_SCALE: 1,
        CUSTOM_ROW_NAMES: false,
        ROW_NAMES: []
    },
    SCENA_6: {
        ROWS_AMOUNT: 17,
        MAX_SEATS_AMOUNT: 21,
        SEATS_LEFT_TO_RIGHT: false,
        INIT_MOBILE_SCALE: 0.4,
        INIT_DESKTOP_SCALE: 0.75,
        CUSTOM_ROW_NAMES: false,
        ROW_NAMES: []
    },
    NOBEL_MUSE_HALL: {
        ROWS_AMOUNT: 17,
        MAX_SEATS_AMOUNT: 30,
        SEATS_LEFT_TO_RIGHT: true,
        INIT_MOBILE_SCALE: 0.35,
        INIT_DESKTOP_SCALE: 0.6,
        CUSTOM_ROW_NAMES: false,
        ROW_NAMES: []
    },
    HORA: {
        ROWS_AMOUNT: 6,
        MAX_SEATS_AMOUNT: 22,
        SEATS_LEFT_TO_RIGHT: false,
        INIT_MOBILE_SCALE: 0.5,
        INIT_DESKTOP_SCALE: 0.8,
        CUSTOM_ROW_NAMES: true,
        ROW_NAMES: ['1', '1a', '2', '3', '4', '5']
    }
};

export default SEAT_MAPS;